import * as editAccount from './editAccount'
import * as editCustomizations from './customization'
import * as editDepartment from './editDepartment'
import * as fetchAccount from './fetchAccount'
import * as fetchMemberUpgradeRequests from './fetchMemberUpgradeRequests'
import * as fetchMyMembers from './fetchMyMembers'
import * as removePermission from './removePermission'
import * as updateLogo from './updateLogo'
import * as fetchLimitedMembers from './fetchLimitedMembers'

module.exports = {
  ...editAccount,
  ...editCustomizations,
  ...editDepartment,
  ...fetchAccount,
  ...fetchMemberUpgradeRequests,
  ...fetchMyMembers,
  ...fetchLimitedMembers,
  ...removePermission,
  ...updateLogo,
}
